module.exports = __webpack_public_path__ + "static/media/cam-outline-blue.69066b6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cam-outline-blue.svg
// module id = 236
// module chunks = 0